import React, { PropsWithChildren } from 'react';

import { SearchResult } from '@lumapps/search/types';

/** Context to store the raw search result and easily access the data */
export const SearchResultContext = React.createContext<SearchResult | undefined>(undefined);

/** Props for the SearchResultContextProvider */
interface SearchResultContextProviderProps {
    /** The result displayed */
    result: SearchResult;
}

/** Context Provider for search results. */
export const SearchResultContextProvider: React.FC<PropsWithChildren<SearchResultContextProviderProps>> = ({
    children,
    result,
}) => <SearchResultContext.Provider value={result}>{children}</SearchResultContext.Provider>;
